import * as React from "react"
import * as Immutable from 'immutable'
import { LinkListItem } from "../../../types/types";

type Props = {
  title: string
  items: Immutable.List<LinkListItem>

}

export const LinkListItems = (props : Props) : JSX.Element => (
  <div>
    <h3>{props.title}</h3>
    <ul className="link-list">
    {props.items.map((x, i) => (
      <li className="link-list__item" key={i}>
        <a href={x.url} className="link-list__link">
          {x.title}
        </a>
      </li>
    ))}
    </ul>
  </div>
)
